import { without, includes } from "lodash";
/**
 * Mixin to handle firing and binding events which allow communication between controllers and views
 */
const EventsMixin = {
	/** return active events
	 * @param type - type of event
	 */
	getEvents: function ( type ) {
		if ( !this._customEventHandlers ) {
			this._customEventHandlers = {};
		}
		if ( !!type ) {
			return this._customEventHandlers[this.getEventName( type )] || [];
		}
		return this._customEventHandlers;
	},

	getEventName: function ( type ) {
		if ( typeof type !== `undefined` ) {
			return type.replace( /^on/, `` ).toLowerCase();
		}
		return null;
	},
	/**
	 * @param {string} type - type of event
	 * @param {function} function - callback function when event is fired
	 * @param {boolean} once - if true, event will only be fired once
	 */
	addEvent: function ( type, func, once ) {
		const evs = this.getEvents();

		type = this.getEventName( type );
		if ( typeof evs[type] === `undefined` ) {
			evs[type] = [];
		}
		if ( once ) {
			const _func = func;

			func = function () {
				_func( ...arguments );
				this.removeEvent( type, func );
			}.bind( this );
		}
		evs[type].push( func );
	},
	/**
	 * remove event to that is no longer listening
	 */
	removeEvent: function ( type, fn ) {
		type = this.getEventName( type );
		const evs = this.getEvents();

		if ( typeof evs[type] === `undefined` ) {
			return;
		}
		evs[type] = without( evs[type], fn );
	},
	/**
	 * fire event and tell all observers/listeners to act accordingly
	 */
	fireEvent: function ( type, args, observersToSkip ) {
		type = this.getEventName( type );
		const evs = this.getEvents()[type];

		if ( typeof evs === `undefined` ) {
			return;
		}
		const _evs = [];
		let i = evs.length;

		while ( i-- ) {
			_evs[i] = evs[i];
		} // fastest for short arrays, http://jsperf.com/new-array-vs-splice-vs-slice/72
		for ( let i = 0, n = _evs.length; i < n; i++ ) {
			if ( !observersToSkip || !includes( observersToSkip, _evs[i])) {
				_evs[i].apply( null, args );
			}
		}
	},

	/**
	 * Attach a listener that simply refires the event on the listener object
	 *
	 * @param string|string[] the event name(s). Event names are normalized eg) 'onFoo', 'foo', 'onfoo' are equivalent
	 * @param Object The target object to fire the event on
	 */
	propagateEvent: function ( type, obj ) {
		if ( !Array.isArray( type )) {
			type = [ type ];
		}
		for ( let i = 0, n = type.length; i < n; i++ ) {
			this.addEvent( type[i], this.fireEvent.bind( obj, type[i]));
		}
	}
};

export default EventsMixin;
